import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  Box,
  Button,
  Collapse,
  IconButton,
  InputBase,
  Typography,
} from "@mui/material";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import {
  addReferralForPatientBySubModule,
  getPatientForm,
  getQuestionModule,
  setPatientForm,
} from "../../../../api/area";
import DeleteIcon from "../../../../assets/SVG/deleteIcon";
import DownArrow from "../../../../assets/SVG/downArrow";
import ReferralIcon from "../../../../assets/SVG/referralIcon";
import UploadIconParvandeh from "../../../../assets/SVG/uploadIconParvandeh";
import CustomizedHook from "../../../project/autocomplatePro";
import DatePicker from "../../../project/datePicker";
import { CheckBoxBranch } from "../../../signin/chekboxListBranch";
import DateInputComponent from "./dateInputComponenet";
import { useSearchParams } from "react-router-dom";
import {
  findQuestionById,
  parseTableAnswer,
  serializeTableAnswer,
} from "./tableUtils";
import TableQuestion from "./TableQuestion";

const GeneralSieve = ({ data, areaId, moduleId }) => {
  const [params] = useSearchParams();
  const [patientId] = useMemo(() => {
    return [params.get("patientId")];
  }, [params]);

  const [collapseQarbal, setCollapseQarbal] = useState(false);
  const [questions, setQuestions] = useState(null);
  const [showDatePicker, setShowDatePicker] = useState(null);
  const [formData, setFormData] = useState([]);
  const [files, setFiles] = useState([]);

  const handleChange = useCallback((id, value, type) => {
    setFormData((prevData) => {
      const existingIndex = prevData.findIndex(
        (item) => item.questionId === id,
      );

      if (existingIndex > -1) {
        const newData = [...prevData];
        newData[existingIndex] = {
          ...newData[existingIndex],
          [type]: String(value), // تبدیل مقدار به رشته
        };
        return newData;
      }

      return [
        ...prevData,
        {
          questionId: id,
          [type]: String(value), // تبدیل مقدار به رشته
        },
      ];
    });
  }, []);

  // تابع برای مشاهده فایل
  // const handleViewFile = (file) => {
  //   // ایجاد URL برای فایل
  //   const fileURL = URL.createObjectURL(file);

  //   // باز کردن فایل در پنجره جدید
  //   window.open(fileURL, "_blank");

  //   // یا می‌توانید از یک modal برای نمایش فایل استفاده کنید
  //   // setPreviewFile(fileURL);
  //   // setOpenPreview(true);
  // };
  const handleViewFile = (file) => {
    // اگر file یک رشته (URL) است، مستقیماً بازش کن
    if (typeof file === "string") {
      window.open(file, "_blank");
    }
    // اگر file یک File object است
    else if (file instanceof File) {
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL, "_blank");
    }
    // یا می‌توانید از یک modal برای نمایش فایل استفاده کنید
    // setPreviewFile(fileURL || file);
    // setOpenPreview(true);
  };

  // تابع برای حذف فایل
  const handleRemoveFile = (questionId, index) => {
    setFiles((prevFiles) => {
      const newFiles = [...prevFiles];
      newFiles[index] = null;
      return newFiles;
    });

    setFormData((prevData) => {
      return prevData.filter((item) => item.questionId !== questionId);
    });
  };

  const handleCheckboxChange = useCallback(
    (optionKey, questionId) => {
      const item = formData.find((item) => item.questionId === questionId);

      setFormData((prev) =>
        item !== undefined
          ? item.answer === optionKey
            ? prev.filter(
                (item) =>
                  !(
                    item.answer === optionKey && item.questionId === questionId
                  ),
              )
            : prev.map((item) => {
                if (item.questionId === questionId) {
                  return { answer: optionKey, questionId: questionId };
                }
                return item;
              })
          : [...prev, { answer: optionKey, questionId: questionId }],
      );
    },
    [formData],
  );

  const handleFileChange = useCallback((id, file, index) => {
    setFiles((prevFiles) => {
      const newFiles = [...prevFiles];
      newFiles[index] = { questionId: id, file };
      return newFiles;
    });

    setFormData((prevData) => {
      const existingIndex = prevData.findIndex(
        (item) => item.questionId === id,
      );
      if (existingIndex > -1) {
        const newData = [...prevData];
        newData[existingIndex] = {
          ...newData[existingIndex],
          fileIndex: index,
        };
        return newData;
      }
      return [...prevData, { questionId: id, fileIndex: index }];
    });
  }, []);

  //   const formDataFile = new FormData();
  //   const finalData = [];

  //   // پردازش فایل‌ها
  //   files.forEach((fileObj, index) => {
  //     if (fileObj?.file) {
  //       formDataFile.append('files', fileObj.file);
  //     }
  //   });

  //   // پردازش سوالات
  //   questions?.questions?.forEach((question) => {
  //     // پردازش سوالات CHECK_LIST (فرمت جدید خدمات روان شناس)
  //     if (question.questionType === "CHECK_LIST") {
  //       // حالت: سوالات زیرمجموعه داره
  //       if (Array.isArray(question.questions)) {
  //         question.questions.forEach((subQuestion) => {
  //           const answerData = formData.find(
  //             (item) => item.questionId === subQuestion.id
  //           );

  //           if (answerData) {
  //             const answerItem = {
  //               questionId: subQuestion.id,
  //               answer: answerData.answer || "",
  //               ...(question.canWriteDesc && answerData.desc && {
  //                 desc: answerData.desc,
  //               }),
  //               ...(question.canWriteTime && answerData.time && {
  //                 time: answerData.time,
  //               }),
  //               ...(question.canWriteReport && answerData.report && {
  //                 report: answerData.report,
  //               }),
  //               ...(question.canWriteReason && answerData.reason && {
  //                 reason: answerData.reason,
  //               }),
  //               ...(question.canUploadFile && {
  //                 fileIndex: files.findIndex(
  //                   (f) => f.questionId === subQuestion.id
  //                 ),
  //               }),
  //             };
  //             finalData.push(answerItem);
  //           }
  //         });
  //       } else {
  //         // حالت: خودش سوال تکی با CHECK_LIST و TICK
  //         const selectedOptions = formData.filter(
  //           (item) => item.questionId === question.id
  //         );
  //         selectedOptions.forEach((option) => {
  //           finalData.push({
  //             questionId: question.id,
  //             answer: option.answer,
  //           });
  //         });
  //       }
  //     }

  //     // پردازش سوالات جدولی
  //     else if (question.questionType === "TABLE") {
  //       const tableAnswers = formData.filter(item => item.questionId === question.id);

  //       const maxRow = Math.max(...tableAnswers.map(a => a.rowIndex || 0));
  //       const maxCol = Math.max(...tableAnswers.map(a => a.columnIndex || 0));
  //       const matrix = Array(maxRow + 1).fill().map(() => Array(maxCol + 1).fill(""));

  //       tableAnswers.forEach(item => {
  //         if (item.rowIndex !== undefined && item.columnIndex !== undefined) {
  //           matrix[item.rowIndex][item.columnIndex] = item.answer || "";
  //         }
  //       });

  //       let combinedAnswer = "";
  //       for (let row = 0; row <= maxRow; row++) {
  //         for (let col = 0; col <= maxCol; col++) {
  //           combinedAnswer += `${matrix[row][col]}__`;
  //         }
  //       }
  //       combinedAnswer = combinedAnswer.replace(/__$/, "");

  //       finalData.push({
  //         questionId: question.id,
  //         answer: combinedAnswer
  //       });
  //     }
  //     // پردازش سوالات گروهی
  //     else if (question.questionType === "GROUP") {
  //       question.questions?.forEach((subQuestion) => {
  //         if (subQuestion.questionType === "TABLE") {
  //           const tableAnswers = formData.filter(item => item.questionId === subQuestion.id);

  //           const maxRow = Math.max(...tableAnswers.map(a => a.rowIndex || 0));
  //           const maxCol = Math.max(...tableAnswers.map(a => a.columnIndex || 0));
  //           const matrix = Array(maxRow + 1).fill().map(() => Array(maxCol + 1).fill(""));

  //           tableAnswers.forEach(item => {
  //             if (item.rowIndex !== undefined && item.columnIndex !== undefined) {
  //               matrix[item.rowIndex][item.columnIndex] = item.answer || "";
  //             }
  //           });

  //           let combinedAnswer = "";
  //           for (let row = 0; row <= maxRow; row++) {
  //             for (let col = 0; col <= maxCol; col++) {
  //               combinedAnswer += `${matrix[row][col]}__`;
  //             }
  //           }
  //           combinedAnswer = combinedAnswer.replace(/__$/, "");

  //           finalData.push({
  //             questionId: subQuestion.id,
  //             answer: combinedAnswer
  //           });
  //         }
  //         else {
  //           const answerData = formData.find(item => item.questionId === subQuestion.id);
  //           if (answerData) {
  //             const answerItem = {
  //               questionId: subQuestion.id,
  //               answer: answerData.answer || "",
  //               ...(answerData.desc && { desc: answerData.desc }),
  //               ...(answerData.time && { time: answerData.time }),
  //               ...(answerData.report && { report: answerData.report }),
  //               ...(answerData.reason && { reason: answerData.reason }),
  //               ...(subQuestion.canUploadFile && {
  //                 fileIndex: files.findIndex(f => f.questionId === subQuestion.id)
  //               })
  //             };
  //             finalData.push(answerItem);
  //           }
  //         }
  //       });
  //     }
  //     // پردازش سایر سوالات
  //     else {
  //       const answerData = formData.find(item => item.questionId === question.id);
  //       if (answerData) {
  //         const answerItem = {
  //           questionId: question.id,
  //           answer: answerData.answer || "",
  //           ...(answerData.desc && { desc: answerData.desc }),
  //           ...(answerData.time && { time: answerData.time }),
  //           ...(answerData.report && { report: answerData.report }),
  //           ...(answerData.reason && { reason: answerData.reason }),
  //           ...(question.canUploadFile && {
  //             fileIndex: files.findIndex(f => f.questionId === question.id)
  //           })
  //         };
  //         finalData.push(answerItem);
  //       }
  //     }
  //   });

  //   // فیلتر کردن مقادیر خالی
  //   const filteredData = finalData.filter(item =>
  //     item.answer !== "" && item.answer !== " "
  //   );

  //   // ارسال به سرور
  //   setPatientForm(
  //     patientId,
  //     moduleId,
  //     data?.id,
  //     referralId,
  //     encodeURI(JSON.stringify(filteredData)),
  //     formDataFile
  //   )
  //     .then(() => toast.success("ثبت شد"))
  //     .catch(() => toast.error("خطا در ثبت اطلاعات"));
  // }, [formData, files, patientId, moduleId, data?.id, referralId, questions]);
  const handleSubmit = useCallback(() => {
    const formDataFile = new FormData();
    const finalData = [];

    // پردازش فایل‌ها
    files.forEach((fileObj) => {
      if (fileObj?.file) {
        formDataFile.append("files", fileObj.file);
      }
    });

    // پردازش سوالات
    questions?.questions?.forEach((question) => {
      // پردازش سوالات CHECK_LIST (فرمت جدید خدمات روان شناس)
      if (question.questionType === "CHECK_LIST") {
        // حالت: سوالات زیرمجموعه داره
        if (Array.isArray(question.questions)) {
          question.questions.forEach((subQuestion) => {
            const answerData = formData.find(
              (item) => item.questionId === subQuestion.id,
            );

            if (answerData) {
              const answerItem = {
                questionId: subQuestion.id,
                answer: answerData.answer || "",
                ...(question.canWriteDesc &&
                  answerData.desc && {
                    desc: answerData.desc,
                  }),
                ...(question.canWriteTime &&
                  answerData.time && {
                    time: answerData.time,
                  }),
                ...(question.canWriteReport &&
                  answerData.report && {
                    report: answerData.report,
                  }),
                ...(question.canWriteReason &&
                  answerData.reason && {
                    reason: answerData.reason,
                  }),
                ...(question.canUploadFile && {
                  fileIndex: files.findIndex(
                    (f) => f && f.questionId === subQuestion.id, // اضافه کردن بررسی وجود f
                  ),
                }),
              };
              finalData.push(answerItem);
            }
          });
        } else {
          // حالت: خودش سوال تکی با CHECK_LIST و TICK
          const selectedOptions = formData.filter(
            (item) => item.questionId === question.id,
          );
          selectedOptions.forEach((option) => {
            finalData.push({
              questionId: question.id,
              answer: option.answer,
            });
          });
        }
      } else if (question.questionType === "TABLE") {
        const answer = serializeTableAnswer(
          formData,
          question.id,
          question.rowsCount,
          question.headers.length - 1,
        );

        if (answer.replaceAll("__", "") !== "") {
          finalData.push({
            questionId: question.id,
            answer,
          });
        }
      }
      // پردازش سوالات گروهی
      else if (question.questionType === "GROUP") {
        question.questions?.forEach((subQuestion) => {
          if (subQuestion.questionType === "TABLE") {
            const answer = serializeTableAnswer(
              formData,
              subQuestion.id,
              subQuestion.rowsCount,
              subQuestion.headers.length - 1,
            );

            if (answer.replaceAll("__", "") !== "") {
              finalData.push({
                questionId: subQuestion.id,
                answer,
              });
            }
          } else {
            const answerData = formData.find(
              (item) => item.questionId === subQuestion.id,
            );
            if (answerData) {
              const answerItem = {
                questionId: subQuestion.id,
                answer: answerData.answer || "",
                ...(answerData.desc && { desc: answerData.desc }),
                ...(answerData.time && { time: answerData.time }),
                ...(answerData.report && { report: answerData.report }),
                ...(answerData.reason && { reason: answerData.reason }),
                ...(subQuestion.canUploadFile && {
                  fileIndex: files.findIndex(
                    (f) => f && f.questionId === subQuestion.id,
                  ), // اضافه کردن بررسی وجود f
                }),
              };
              finalData.push(answerItem);
            }
          }
        });
      }
      // پردازش سایر سوالات
      else {
        const answerData = formData.find(
          (item) => item.questionId === question.id,
        );
        if (answerData) {
          const answerItem = {
            questionId: question.id,
            answer: answerData.answer || "",
            ...(answerData.desc && { desc: answerData.desc }),
            ...(answerData.time && { time: answerData.time }),
            ...(answerData.report && { report: answerData.report }),
            ...(answerData.reason && { reason: answerData.reason }),
            ...(question.canUploadFile && {
              fileIndex: files.findIndex(
                (f) => f && f.questionId === question.id,
              ), // اضافه کردن بررسی وجود f
            }),
          };
          finalData.push(answerItem);
        }
      }
    });

    // فیلتر کردن مقادیر خالی
    const filteredData = finalData.filter(
      (item) => item.answer !== "" && item.answer !== " ",
    );

    // ارسال به سرور
    setPatientForm(
      areaId,
      moduleId,
      data?.id,
      patientId,
      encodeURIComponent(JSON.stringify(filteredData)),
      formDataFile,
    )
      .then(() => toast.success("ثبت شد"))
      .catch(() => toast.error("خطا در ثبت اطلاعات"));
  }, [formData, files, patientId, moduleId, data?.id, areaId, questions]);

  const handleReferral = useCallback(() => {
    addReferralForPatientBySubModule(areaId, moduleId, data?.id, patientId)
      .then(() => toast.success("ارجاع داده شد"))
      .catch(() => toast.error("خطا در ارجاع"));
  }, [patientId, moduleId, data?.id, areaId]);

  const fetchModuleQuestions = useCallback(() => {
    getQuestionModule(areaId, moduleId, data?.id)
      .then(setQuestions)
      .catch(() => toast.error("خطا در دریافت سوالات"));
  }, [areaId, moduleId, data?.id, collapseQarbal]);

  useEffect(() => {
    if (areaId && collapseQarbal) {
      fetchModuleQuestions();
    }
  }, [areaId, collapseQarbal]);

  const fetchPatientForm = useCallback(() => {
    getPatientForm(areaId, moduleId, data?.id, patientId)
      .then((result) => {
        const parsed = [];

        result.forEach((item) => {
          const question = findQuestionById(item.questionId, questions);
          if (question?.questionType === "TABLE") {
            parsed.push(
              ...parseTableAnswer(
                item.answer,
                item.questionId,
                question.firstColumn.length,
                question.headers.length - 1,
              ),
            );
          } else {
            parsed.push(item);
          }
        });

        setFormData(parsed);
      })
      .catch(() => {
        setFormData([]);
      });
  }, [questions, data, collapseQarbal, patientId, moduleId, areaId]);

  useEffect(() => {
    if (data && collapseQarbal && questions) {
      fetchPatientForm();
    }
  }, [data, collapseQarbal, questions]);

  const renderRadioOptions = (question, elem, INDEX) => (
    <>
      {elem?.options?.map((y, index) => (
        <Box
          key={`radio-${index}`}
          mr={index === 0 ? "10px" : index % 2 === 0 ? "40px" : "20px"}
        >
          {INDEX === 0 && (
            <Typography pt="5px" height="10px" fontSize="10px">
              {y.value}
            </Typography>
          )}
          <CheckBoxBranch
            onChange={() => handleCheckboxChange(y.key, elem.id)}
            width={
              !question.canUploadFile && !question.canWriteDesc
                ? "100px"
                : question.canWriteDesc || question.canWriteReason
                  ? "70px"
                  : "40px"
            }
            checked={formData.some(
              (item) => item.answer === y.key && item.questionId === elem.id,
            )}
          />
        </Box>
      ))}
    </>
  );

  const renderInputField = (question, type) => (
    <InputBase
      multiline={type === "LONG_TEXT"}
      value={formData.find((q) => q.questionId === question.id)?.answer || ""}
      onChange={(e) => handleChange(question.id, e.target.value, "answer")}
      sx={{
        height: type === "LONG_TEXT" ? "150px" : "40px",
        bgcolor: "white",
        border: "solid 1px #636971",
        overflow: "auto",
        px: "5px",
        borderRadius: "6px",
        width: "100%",
        "& .MuiInputBase-input": {
          height: "100% !important",
        },
      }}
    />
  );

  const renderCheckList = (question, index) => (
    <Box key={`checklist-${index}`}>
      {question.sectionTitle && (
        <Typography
          p="15px 10px"
          borderBottom="solid 1px #F6F4F3"
          fontWeight="bold"
          color="var(--emr-darkblue)"
        >
          {question.sectionTitle}
        </Typography>
      )}

      {Array.isArray(question.questions)
        ? question.questions.map((subQuestion, subIndex) => (
            <Box
              key={`checklist-item-${subIndex}`}
              display="flex"
              justifyContent="space-between"
              borderBottom="solid 1px #F6F4F3"
              alignItems="center"
              py="10px"
            >
              <Box p="10px" width="40%">
                {subQuestion.question}
              </Box>

              <Box width="60%" display="flex" alignItems="center">
                <Box display="flex" mr="20px">
                  {question.options?.map((option, optIndex) => (
                    <Box key={`option-${optIndex}`} mr="15px">
                      <Typography fontSize="12px">{option.value}</Typography>
                      <CheckBoxBranch
                        onChange={() =>
                          handleCheckboxChange(option.key, subQuestion.id)
                        }
                        checked={formData.some(
                          (item) =>
                            item.answer === option.key &&
                            item.questionId === subQuestion.id,
                        )}
                        width="100px"
                      />
                    </Box>
                  ))}
                </Box>

                {question.canWriteTime && (
                  <Box ml="15px">
                    <InputBase
                      placeholder="زمان"
                      sx={{
                        height: "40px",
                        bgcolor: "white",
                        border: "solid 1px #636971",
                        px: "5px",
                        borderRadius: "6px",
                        width: "100px",
                      }}
                      value={
                        formData.find((q) => q.questionId === subQuestion.id)
                          ?.time || ""
                      }
                      onChange={(e) =>
                        handleChange(subQuestion.id, e.target.value, "time")
                      }
                    />
                  </Box>
                )}

                {question.canWriteDesc && (
                  <Box ml="15px" flexGrow={1}>
                    <InputBase
                      placeholder="توضیحات"
                      sx={{
                        height: "40px",
                        bgcolor: "white",
                        border: "solid 1px #636971",
                        px: "5px",
                        borderRadius: "6px",
                        width: "100%",
                      }}
                      value={
                        formData.find((q) => q.questionId === subQuestion.id)
                          ?.desc || ""
                      }
                      onChange={(e) =>
                        handleChange(subQuestion.id, e.target.value, "desc")
                      }
                    />
                  </Box>
                )}

                {/* {question.canUploadFile && (
                  <Box ml="15px">
                    <Box
                      width="80px"
                      borderRadius="6px"
                      display="flex"
                      justifyContent="space-around"
                      alignItems="center"
                      component="label"
                      height="39px"
                      border="dashed 1px black"
                      bgcolor="white"
                      sx={{ cursor: "pointer" }}
                    >
                      <input
                        type="file"
                        hidden
                        onChange={(e) =>
                          handleFileChange(
                            subQuestion.id,
                            e.target.files[0],
                            subIndex
                          )
                        }
                      />
                      <UploadIconParvandeh />
                    </Box>
                  </Box>
                )} */}
                {question.canUploadFile && (
                  <Box ml="15px">
                    {files[subIndex]?.questionId === subQuestion.id ||
                    formData.find((item) => item.questionId === subQuestion.id)
                      ?.additionalUploadedFile ? (
                      <Box display="flex" alignItems="center" gap="10px">
                        {/* دکمه مشاهده فایل */}
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() => {
                            const currentFile =
                              files[subIndex]?.file ||
                              formData.find(
                                (item) => item.questionId === subQuestion.id,
                              )?.additionalUploadedFile;
                            handleViewFile(currentFile);
                          }}
                          startIcon={<VisibilityIcon />}
                        ></Button>

                        {/* دکمه حذف فایل */}
                        <IconButton
                          size="small"
                          onClick={() =>
                            handleRemoveFile(subQuestion.id, subIndex)
                          }
                          color="error"
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Box>
                    ) : (
                      <Box
                        width="80px"
                        borderRadius="6px"
                        display="flex"
                        justifyContent="space-around"
                        alignItems="center"
                        component="label"
                        height="39px"
                        border="dashed 1px black"
                        bgcolor="white"
                        sx={{ cursor: "pointer" }}
                      >
                        <input
                          type="file"
                          hidden
                          onChange={(e) =>
                            handleFileChange(
                              subQuestion.id,
                              e.target.files[0],
                              subIndex,
                            )
                          }
                        />
                        <UploadIconParvandeh />
                      </Box>
                    )}
                  </Box>
                )}
              </Box>
            </Box>
          ))
        : question.answerType === "TICK" &&
          question.options?.length > 0 && (
            <Box
              display="flex"
              justifyContent="space-between"
              borderBottom="solid 1px #F6F4F3"
              alignItems="center"
              py="10px"
            >
              <Box p="10px" width="40%">
                {question.question}
              </Box>

              <Box width="60%" display="flex" alignItems="center">
                {question.options.map((option, optIndex) => (
                  <Box key={`tick-option-${optIndex}`} mr="15px">
                    <Typography fontSize="12px">{option.value}</Typography>
                    <CheckBoxBranch
                      onChange={() =>
                        handleCheckboxChange(option.key, question.id)
                      }
                      checked={formData.some(
                        (item) =>
                          item.answer === option.key &&
                          item.questionId === question.id,
                      )}
                      width="100px"
                    />
                  </Box>
                ))}
              </Box>
            </Box>
          )}
    </Box>
  );

  const renderActionButtons = () => (
    <Box mt="10px" display="flex" justifyContent="end">
      <button
        style={{
          border: "none",
          backgroundColor: "var(--emr-darkblue)",
          color: "white",
          padding: "5px 40px",
          borderRadius: "10px",
          marginLeft: "10px",
          cursor: "pointer",
        }}
        onClick={handleSubmit}
      >
        ثبت
      </button>
      {data?.isReferral && (
        <Box
          style={{
            border: "none",
            backgroundColor: "#E09856",
            color: "white",
            padding: "5px 40px",
            borderRadius: "10px",
            marginLeft: "10px",
            cursor: "pointer",
            display: "flex",
            gap: "5px",
            alignItems: "center",
          }}
          onClick={handleReferral}
        >
          <ReferralIcon />
          <Typography color="white">ارجاع</Typography>
        </Box>
      )}
    </Box>
  );

  return (
    <>
      <DatePicker
        sx={{ marginLeft: "-30px !important" }}
        show={showDatePicker}
        setShow={setShowDatePicker}
      />
      <Box
        onClick={() => setCollapseQarbal(!collapseQarbal)}
        bgcolor="#EFF1F7"
        borderRadius="7px"
        p="10px"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mt="20px"
        sx={{ cursor: "pointer" }}
      >
        <Typography color="var(--emr-darkblue)">{data?.name}</Typography>
        <DownArrow transform={collapseQarbal} />
      </Box>
      <Collapse in={collapseQarbal} timeout="auto">
        <Box mt="-5px" bgcolor="#EFF1F7" p="20px">
          <Box
            display="grid"
            bgcolor="#F5F9FF"
            boxShadow="0px 4px 4px 0px #00000040"
            p="20px"
            borderRadius="16px"
            mt="20px"
            sx={{ overflow: "auto" }}
          >
            {questions?.questions?.map((x, index) => (
              <React.Fragment key={`question-${index}`}>
                {x.questionType === "TABLE" && (
                  <TableQuestion
                    key={index}
                    question={x}
                    formData={formData}
                    setFormData={setFormData}
                  />
                )}

                {x.questionType === "CHECK_LIST" && renderCheckList(x, index)}

                {x.sectionTitle && x.questionType !== "CHECK_LIST" && (
                  <Typography
                    p="15px 10px"
                    borderBottom="solid 1px #F6F4F3"
                    fontWeight="bold"
                    color="var(--emr-darkblue)"
                  >
                    {x.sectionTitle}
                  </Typography>
                )}

                {x.questionType === "GROUP" && (
                  <>
                    {x.questions?.map((elem, INDEX) => (
                      <React.Fragment key={`group-question-${INDEX}`}>
                        {elem.questionType === "TABLE" ? (
                          <TableQuestion
                            question={elem}
                            key={INDEX}
                            formData={formData}
                            setFormData={setFormData}
                          />
                        ) : (
                          <Box
                            display="flex"
                            justifyContent="space-between"
                            borderBottom="solid 1px #F6F4F3"
                          >
                            <Box
                              p="18px"
                              width={
                                elem.answerType === "LONG_TEXT" ? "20%" : "60%"
                              }
                              mt={elem.answerType === "RADIO" && "15px"}
                            >
                              {elem.question}
                            </Box>

                            {elem.answerType === "UPLOAD" && (
                              <Box>
                                {INDEX === 0 && (
                                  <Typography
                                    textAlign="center"
                                    height="40px"
                                    fontSize="10px"
                                  >
                                    بارگذاری فایل
                                  </Typography>
                                )}
                                <Box
                                  width="290px"
                                  mr="20px"
                                  borderRadius="6px"
                                  display="flex"
                                  justifyContent="space-around"
                                  alignItems="center"
                                  component="label"
                                  height="39px"
                                  mt="9px"
                                  border="dashed 1px black"
                                  bgcolor="white"
                                  sx={{ cursor: "pointer" }}
                                >
                                  <input
                                    type="file"
                                    hidden
                                    onChange={(e) =>
                                      handleFileChange(
                                        elem.id,
                                        e.target.files[0],
                                        INDEX,
                                      )
                                    }
                                  />
                                  <UploadIconParvandeh />
                                </Box>
                              </Box>
                            )}

                            {elem.answerType === "SELECT" && (
                              <Box
                                sx={{ overflow: "hidden" }}
                                width="40%"
                                pb="20px"
                              >
                                <CustomizedHook
                                  width="40%"
                                  placeholder="انتخاب کنید."
                                  options={elem.options}
                                  onChange={(_, newValue) =>
                                    handleChange(
                                      elem.id,
                                      newValue.key,
                                      "answer",
                                    )
                                  }
                                  value={
                                    elem.options.find(
                                      (option) =>
                                        option.key ===
                                        formData.find(
                                          (item) => item.questionId === elem.id,
                                        )?.answer,
                                    ) || null
                                  }
                                />
                              </Box>
                            )}

                            {(elem.answerType === "TEXT" ||
                              elem.answerType === "NUMBER") && (
                              <Box
                                display="flex"
                                alignItems="center"
                                width="70%"
                                justifyContent="space-around"
                              >
                                <InputBase
                                  sx={{
                                    height: "40px",
                                    bgcolor: "white",
                                    border: "solid 1px #636971",
                                    px: "5px",
                                    borderRadius: "6px",
                                    textAlign: "center",
                                  }}
                                  value={
                                    formData.find(
                                      (q) => q.questionId === elem.id,
                                    )?.answer || ""
                                  }
                                  onChange={(e) => {
                                    handleChange(
                                      elem.id,
                                      elem.answerType === "NUMBER"
                                        ? Number(e.target.value)
                                        : e.target.value,
                                      "answer",
                                    );
                                  }}
                                />
                              </Box>
                            )}

                            {elem.answerType === "RADIO" &&
                              renderRadioOptions(x, elem, INDEX)}

                            {(elem.answerType === "LONG_TEXT" ||
                              elem.canWriteDesc) && (
                              <Box
                                width={
                                  elem.answerType === "LONG_TEXT"
                                    ? "70%"
                                    : "40%"
                                }
                                justifyContent="space-between"
                                display="flex"
                              >
                                <Box
                                  display="flex"
                                  width="100%"
                                  justifyContent="space-around"
                                  alignItems="center"
                                >
                                  {renderInputField(elem, elem.answerType)}
                                </Box>
                              </Box>
                            )}
                          </Box>
                        )}
                      </React.Fragment>
                    ))}
                  </>
                )}

                {x.questionType === "SIMPLE" && (
                  <>
                    {x.answerType === "UPLOAD" && (
                      <Box
                        display={"flex"}
                        alignItems="center"
                        justifyContent="space-between"
                      >
                        <Typography>{x.question}</Typography>
                        <Box
                          width="290px"
                          mr="20px"
                          borderRadius="6px"
                          display="flex"
                          justifyContent="space-around"
                          alignItems="center"
                          component="label"
                          height="39px"
                          mt="9px"
                          border="dashed 1px black"
                          bgcolor="white"
                          sx={{ cursor: "pointer" }}
                        >
                          <input
                            type="file"
                            hidden
                            onChange={(e) =>
                              handleFileChange(x.id, e.target.files[0], index)
                            }
                          />
                          <UploadIconParvandeh />
                        </Box>
                      </Box>
                    )}
                    {x.answerType === "SELECT" && (
                      <Box pb="20px">
                        <CustomizedHook
                          placeholder="انتخاب کنید."
                          label={x.question}
                          options={x.options}
                          onChange={(_, newValue) =>
                            handleChange(x.id, newValue.key, "answer")
                          }
                          value={
                            x.options.find(
                              (option) =>
                                option.key ===
                                formData.find(
                                  (item) => item.questionId === x.id,
                                )?.answer,
                            ) || null
                          }
                        />
                      </Box>
                    )}

                    {/* {x.answerType === "DATE" && (
                      <Box pb="20px">
                        <InputCreateProject
                          onClick={(e) => setShowDatePicker(e.currentTarget)}
                          label={x.question}
                        />
                      </Box>
                    )} */}
                    {x.answerType === "DATE" && (
                      <DateInputComponent
                        x={x}
                        formData={formData}
                        setFormData={setFormData}
                        index={index}
                        isGregorian={false} // یا true اگر می‌خواهید از تاریخ میلادی استفاده کنید
                      />
                    )}

                    {x.answerType !== "SELECT" &&
                      x.answerType !== "TICK" &&
                      x.answerType !== "UPLOAD" &&
                      x.answerType !== "DATE" && (
                        <Box
                          display="flex"
                          justifyContent="space-between"
                          borderBottom="solid 1px #F6F4F3"
                        >
                          <Box
                            p="18px"
                            width={x.answerType === "LONG_TEXT" ? "20%" : "60%"}
                          >
                            {x.question}
                          </Box>
                          <Box
                            width={x.answerType === "LONG_TEXT" ? "70%" : "40%"}
                            justifyContent="space-between"
                            display="flex"
                          >
                            {(x.answerType === "LONG_TEXT" ||
                              x.canWriteDesc === false) && (
                              <Box
                                display="flex"
                                width="100%"
                                justifyContent="space-around"
                                alignItems="center"
                              >
                                {renderInputField(x, x.answerType)}
                              </Box>
                            )}

                            {(x.answerType === "TEXT" ||
                              x.answerType === "NUMBER") &&
                              x.canWriteDesc === true && (
                                <>
                                  <Box
                                    display="flex"
                                    alignItems="center"
                                    width="35%"
                                    justifyContent="space-around"
                                  >
                                    <InputBase
                                      sx={{
                                        height: "40px",
                                        bgcolor: "white",
                                        border: "solid 1px #636971",
                                        px: "5px",
                                        borderRadius: "6px",
                                        textAlign: "center",
                                      }}
                                      value={
                                        formData.find(
                                          (q) => q.questionId === x.id,
                                        )?.answer || ""
                                      }
                                      onChange={(e) => {
                                        handleChange(
                                          x.id,
                                          x.answerType === "NUMBER"
                                            ? Number(e.target.value)
                                            : e.target.value,
                                          "answer",
                                        );
                                      }}
                                    />
                                  </Box>
                                  <Box
                                    display="flex"
                                    width="55%"
                                    justifyContent="space-around"
                                    alignItems="center"
                                  >
                                    <InputBase
                                      sx={{
                                        height: "40px",
                                        bgcolor: "white",
                                        border: "solid 1px #636971",
                                        px: "5px",
                                        borderRadius: "6px",
                                      }}
                                      value={
                                        formData.find(
                                          (q) => q.questionId === x.id,
                                        )?.desc || ""
                                      }
                                      onChange={(e) =>
                                        handleChange(
                                          x.id,
                                          e.target.value,
                                          "desc",
                                        )
                                      }
                                    />
                                  </Box>
                                </>
                              )}
                          </Box>
                        </Box>
                      )}

                    {x.answerType === "TICK" && (
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        borderBottom="solid 1px #F6F4F3"
                      >
                        <Box p="18px" width="60%">
                          {x.question}
                        </Box>
                        <Box
                          width="40%"
                          justifyContent="space-between"
                          display="flex"
                        >
                          <Box display="flex" width="40%">
                            {x?.options?.map((y, index) => (
                              <Box
                                key={`tick-option-${index}`}
                                mr={
                                  index === 0
                                    ? "10px"
                                    : index % 2 === 0
                                      ? "40px"
                                      : "20px"
                                }
                              >
                                <Typography fontSize="10px">
                                  {y.value}
                                </Typography>
                                <CheckBoxBranch
                                  onChange={() =>
                                    handleCheckboxChange(y.key, x.id)
                                  }
                                  checked={formData.some(
                                    (item) =>
                                      item.answer === y.key &&
                                      item.questionId === x.id,
                                  )}
                                  width="40px"
                                />
                              </Box>
                            ))}
                          </Box>
                        </Box>
                      </Box>
                    )}
                  </>
                )}
              </React.Fragment>
            ))}
            {formData?.length > 0 &&
              typeof formData[formData.length - 1].answer === "string" &&
              formData[formData.length - 1].answer.match(/__mark__(\d+)/) && (
                <Box mt="10px">
                  {`نمره: ${
                    formData[formData.length - 1].answer.match(
                      /__mark__(\d+)/,
                    )[1]
                  }`}
                </Box>
              )}
          </Box>
          {renderActionButtons()}
        </Box>
      </Collapse>
    </>
  );
};

export default React.memo(GeneralSieve);
